module.exports = __webpack_public_path__ + "static/media/engelfriet-min.d6064dd5.png";